import { apicall } from "./api";

export const validateSlug = async (slug, campaign_id) => {
    try {
        const res = await apicall(`/polls/validate/slug?type=${slug}&campaign_id=${campaign_id}`, "GET");
        return res.data;
    } catch (err) {
        return err.response.data;
    }
}